/** @format */

import { Icon } from '@/components/ui/Icon';
import styled from 'styled-components';

export const PromoBannerContainer = styled.div<{ $page: string; $layout?: 'mobile' | 'desktop' }>`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  max-width: ${({ $page }) => $page === 'pdp' && '40.75rem'};

  background: white;

  padding: 1rem;

  margin-block: ${({ $layout }) => {
    if ($layout === 'desktop') return '0 0.5rem';
    return '1rem';
  }};

  margin-right: ${({ $page, $layout }) => $layout === 'mobile' && $page === 'pdp' && '1.56rem'};

  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;

  border: 1px solid
    ${({ $page }) => ($page === 'plp' ? 'var(--gray-300)' : ({ theme }) => theme.colors.joivy['teal-light'])};
  border-radius: ${({ $page }) => ($page === 'plp' ? '0.25rem' : '1rem')};

  ${({ $layout, $page, theme }) =>
    ($layout === 'desktop' &&
      $page === 'pdp' &&
      `@media screen and (max-width: ${theme.breakpoints.lg}) {
    display: none;
  }`) ||
    ($layout === 'mobile' &&
      $page === 'pdp' &&
      `@media screen and (min-width: ${theme.breakpoints.lg}) {
    display: none;
  }`)};
`;

export const TextPromoBanner = styled.p`
  flex: 1;
  margin: 0;
`;

export const IconPromoBanner = styled(Icon)`
  cursor: pointer;
  display: inline;
  position: relative;
  top: 4px;
  align-self: flex-start;
`;
